<script setup lang="ts">
import { toast } from 'vue-sonner'
import type { CommentServiceEntryType } from '@/composables/db/useCommentService'

const props = defineProps({
  modelType: {
    type: String as PropType<CommentServiceEntryType>,
    required: true,
  },
  modelId: {
    type: String,
    required: true,
  },
  commentId: {
    type: String,
    default: '',
  },
  visible: Boolean,
})

const emits = defineEmits(['clearReply'])

const { user, avatarImageUrl, isUserLoggedIn } = storeToRefs(useUserStore())

const composedComment = ref('')
const isReply = computed(() => !!props.commentId)
const { submitComment, replyComment }
= useCommentBase(props.modelType, props.modelId)
const isSubmiting = ref<boolean>(false)

async function respond() {
  if (!user.value)
    return

  if (!composedComment.value)
    return toast.info('請填寫留言內容')

  isSubmiting.value = true
  if (isReply.value) {
    await replyComment(composedComment.value, props.commentId, user.value, avatarImageUrl.value)
  } else {
    await submitComment(composedComment.value, user.value, avatarImageUrl.value)
  }
  clearReply()
  isSubmiting.value = false
}

function clearReply() {
  composedComment.value = ''
  emits('clearReply')
}
</script>

<template>
  <div
    class="pb-safe left-0 right-0 bg-silver z-10 border-neutral-300 fixed md:max-w-md bottom-0 mx-auto border-t textinput-shadow"
  >
    <div v-if="isReply" class="pl-[72px] pt-1 basis-full">
      <span class="text-sm text-neutral-500">正在回覆 ...</span>
      <ui-button
        class="text-sm h-auto text-neutral-900 ml-4 py-1 leading-4"
        variant="link"
        @click="clearReply"
      >
        取消
      </ui-button>
    </div>
    <ui-form class="flex px-6 items-center py-2 gap-2">
      <common-avatar
        :src="avatarImageUrl"
        :alt="user?.name"
        :fallback="user?.name[0]"
      />
      <ui-textarea
        v-model="composedComment"
        class="flex-1 box-border pt-2 h-[36px] bg-white rounded-[20px] pb-1"
      />

      <ui-button
        v-check-login="respond"
        class="rounded-full p-0 h-[30px] w-[30px]"
        :disabled="isSubmiting"
      >
        <i i-ph-paper-plane-right-fill class="text-base" style="color: #fff;" />
      </ui-button>
    </ui-form>

    <aside
      v-if="!isUserLoggedIn"
      v-check-login="respond"
      class="absolute inset-0 bg-slate-900/25"
    />
  </div>
</template>
